import { Badge } from "@/ui/components/primitives/badge";
import { cn } from "@/ui/components/primitives/utils";

interface StatusBadgeProps {
  status: "success" | "pending" | "failed" | "processing" | "completed" | "scheduled" | "active" | "inactive" | "cancelled" | "expired" | "live";
  className?: string;
}

export function StatusBadge({ status, className }: StatusBadgeProps) {
  const variants = {
    success: "bg-success/10 text-success border-success/20 hover:bg-success/20",
    pending: "bg-warning/10 text-warning border-warning/20 hover:bg-warning/20",
    failed: "bg-destructive/10 text-destructive border-destructive/20 hover:bg-destructive/20",
    processing: "bg-primary/10 text-primary border-primary/20 hover:bg-primary/20",
    completed: "bg-success/10 text-success border-success/20 hover:bg-success/20",
    scheduled: "bg-muted text-muted-foreground border-border hover:bg-muted/80",
    active: "bg-success/10 text-success border-success/20 hover:bg-success/20",
    inactive: "bg-muted text-muted-foreground border-border hover:bg-muted/80",
    cancelled: "bg-destructive/10 text-destructive border-destructive/20 hover:bg-destructive/20",
    expired: "bg-muted text-muted-foreground border-border hover:bg-muted/80",
    live: "bg-success/10 text-success border-success/20 hover:bg-success/20",
  };

  const labels = {
    success: "Success",
    pending: "Pending",
    failed: "Failed",
    processing: "Processing",
    completed: "Completed",
    scheduled: "Scheduled",
    active: "Active",
    inactive: "Inactive",
    cancelled: "Cancelled",
    expired: "Expired",
    live: "Live",
  };

  return (
    <Badge className={cn(variants[status], className)}>
      {labels[status]}
    </Badge>
  );
}
